"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.user_group.list': 'Grupos de Usuarios',
    'route.user_group.create': 'Agregar Grupo de Usuarios',
};
